export const isNullOrEmpty = <T>(value: T | null | undefined): boolean => {
  return value === null || value === undefined || value === "";
};
